/**
 * @desc 时效看板-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.TimelinessDashboardResponseDto>
>;
export function request(
  params: API.basics.timelinessDashboard.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/timelinessDashboard/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
